import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  cardSpacing: {
    marginTop: 35,
    marginBottom: 35,
  },
  radioSpacing: {
    marginBottom: 'auto',
  },
  infoBackground: {
    background: '#ECEAEA',
  },
  noPreviewSheet: {
    width: `600px`, // 2px for borders = 0.125rem
    height: `calc(${35}rem + 0.125rem)`, // 2px for borders = 0.125rem
    overflow: 'hidden',
    boxSizing: 'content-box',
    border: '1px solid #cacaca',
    lineHeight: `calc(${35}rem + 0.125rem)`,
    textAlign: 'center',
    color: '#cacaca',
    margin: 'auto',
    borderRadius: 10,
  },
  noPreviewLabel: {
    width: '600px',
    height: '101px',
    position: 'relative',
    margin: '50px auto',
    border: '1px solid #cacaca',
    lineHeight: '101px',
    textAlign: 'center',
    color: '#cacaca',
    borderRadius: 10,
  },
}))

export default useStyles
